import { useState } from 'react';

import { Button, Card, Form, Row, Col } from 'react-bootstrap';

export const PendingApproval = ({ autoApprove, onApprove, onCancel, onSkip, pending }) => {

    const [note, setNote] = useState('');

    // Hide entirely when auto-approving — the card flashes in/out as each step
    // is approved, which is distracting. Toggle auto-approve off to bring it back.
    if (!pending || autoApprove) return null;

    const submit = action => {

        const fn = action === 'approve' ? onApprove : onSkip;
        fn(note || null);
        setNote('');

    };

    return (
        <Card bg="primary" className="border-0 mt-2" text="light">
            <Card.Body>

                <div className="fw-bold mb-1">
                    Approve next step?
                    {autoApprove && (
                        <span className="badge bg-warning text-dark ms-2" style={{ fontSize: 10 }}>
                            auto-approving…
                        </span>
                    )}
                </div>

                <div
                    className="mb-2 text-break"
                    style={{ fontFamily: 'ui-monospace, monospace', fontSize: 12 }}
                >
                    {pending.toolName}
                    (
                    {JSON.stringify(pending.toolInput || {})}
                    )
                </div>

                <Form.Control
                    className="mb-2"
                    onChange={e => setNote(e.target.value)}
                    placeholder="Optional note for the AI…"
                    size="sm"
                    value={note}
                />

                <Row className="g-1">
                    <Col xs={6}>
                        <Button className="w-100" onClick={() => submit('approve')} size="sm" variant="success">
                            Approve
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button className="w-100" onClick={() => submit('skip')} size="sm" variant="warning">
                            Skip
                        </Button>
                    </Col>
                    <Col xs={12}>
                        <Button className="w-100" onClick={onCancel} size="sm" variant="danger">
                            Cancel run
                        </Button>
                    </Col>
                </Row>

            </Card.Body>
        </Card>
    );

};
